// src/components/reviews-carousel/reviews-carousel.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewsCarouselCardFragment on TripsReviewCollectionCarouselCard {\n    card {\n      __typename\n      openedAnalytics\n      description {\n        text\n      }\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      image {\n        description\n        url\n        thumbnailClickAnalytics {\n          referrerId\n          eventType\n          linkName\n        }\n      }\n      ratingLinks {\n        text\n        action {\n          analytics {\n            referrerId\n            eventType\n            linkName\n          }\n          resource {\n            value\n          }\n        }\n      }\n      link {\n        text\n        action {\n          analytics {\n            referrerId\n            eventType\n            linkName\n          }\n          resource {\n            value\n          }\n        }\n      }\n    }\n    id\n    selectedAnalytics\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query ReviewsCarouselQuery($context: ContextInput!) {\n    tripsReviewCollection(context: $context) {\n      reviewsCarousel {\n        heading {\n          text\n        }\n        carousel {\n          carouselId\n          ...EGDSCarouselFragment\n          items {\n            ...ReviewsCarouselCardFragment\n          }\n        }\n        presentedAnalytics\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// src/components/reviews-carousel/utils/track-eg-clickstream.ts
function buildClientPayload(eventName, eventType, eventVersion) {
    var clientPayload = {
        event: {
            event_name: eventName,
            event_version: eventVersion !== null && eventVersion !== void 0 ? eventVersion : "1.0.0" /* GENERAL_VERSION */ ,
            event_type: eventType
        }
    };
    return clientPayload;
}
// src/components/reviews-carousel/utils/trips-review-collection-eg-cickstream-impression-tracker.tsx
import React from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var TripsReviewCollectionEgClickStreamImpressionTracker = function(props) {
    var children = props.children, data = props.data, trackOnce = props.trackOnce;
    return /* @__PURE__ */ React.createElement(EgClickstreamImpressionTracker, {
        eventData: data,
        trackOnce: trackOnce
    }, children);
};
TripsReviewCollectionEgClickStreamImpressionTracker.displayName = "TripsReviewCollectionEgClickStreamImpressionTracker";
// src/components/reviews-carousel/__private/__fragments/card-component.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkInteractiveRating } from "uitk-react-interactive-rating";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacingHr } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var CardComponent = function(param) {
    var data = param.data;
    var _data_card = data.card, description = _data_card.description, heading = _data_card.heading, subHeading = _data_card.subHeading, ratingLinks = _data_card.ratingLinks, image = _data_card.image, openedAnalytics = _data_card.openedAnalytics;
    var track = useEgClickstream();
    var onClickHandler = React2.useCallback(function() {
        track({
            clientPayload: buildClientPayload("trip_review_module.opened", "Interaction" /* INTERACTION */ ),
            serverPayload: openedAnalytics
        });
    }, [
        openedAnalytics,
        track
    ]);
    var onMouseOver = React2.useCallback(function() {
        track({
            clientPayload: buildClientPayload("trip_review_module.selected", "Interaction" /* INTERACTION */ ),
            serverPayload: data.selectedAnalytics
        });
    }, [
        data.selectedAnalytics,
        track
    ]);
    var _React2_useState = _sliced_to_array(React2.useState(), 2), selected = _React2_useState[0], setSelected = _React2_useState[1];
    var urls = React2.useMemo(function() {
        var _ratingLinks;
        return ((_ratingLinks = ratingLinks) === null || _ratingLinks === void 0 ? void 0 : _ratingLinks.map(function(ratingLink) {
            var _ratingLink;
            return (_ratingLink = ratingLink) === null || _ratingLink === void 0 ? void 0 : _ratingLink.action.resource.value;
        })) || [];
    }, [
        ratingLinks
    ]);
    return /* @__PURE__ */ React2.createElement(UitkCard, {
        padded: true,
        border: true,
        onMouseOver: onMouseOver,
        overflow: false
    }, /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        rows: [
            "100px",
            "30px"
        ],
        autoRows: []
    }, /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        columns: [
            "minmax(0, 2fr) minmax(0, 3fr)"
        ]
    }, /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R21_9,
        imageFit: "cover"
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        placeholderImage: true,
        alt: image.description,
        src: image.url
    }))), /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement(UitkCardContentSection, null, /* @__PURE__ */ React2.createElement(UitkText, {
        weight: "bold",
        size: 300,
        overflow: "truncate-3-lines"
    }, heading.text), /* @__PURE__ */ React2.createElement(UitkText, {
        size: 200,
        weight: "regular",
        spacing: "three"
    }, description.text))))), /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSpacingHr, null))), /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkText, {
        size: 400,
        weight: "medium",
        overflow: "truncate-2-lines",
        align: "left"
    }, subHeading.text), /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: [
            "blockstart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React2.createElement(UitkInteractiveRating, {
        valueLabels: [
            "",
            "",
            "",
            "",
            ""
        ],
        onChange: function(event) {
            var selectedIndex = event.currentTarget.value - 1;
            window.location.href = urls[selectedIndex];
            onclick = onClickHandler;
            setSelected(event.currentTarget.value);
        },
        showValueLabel: false,
        showRangeLabels: false,
        rating: Number(selected)
    }))))));
};
CardComponent.fragment = fragment;
CardComponent.displayName = "CardComponent";
// src/components/reviews-carousel/__private/__fragments/egds-carousel.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkCarousel } from "uitk-react-carousel";
var __fragment = gql2(_templateObject1());
var EGDSCarousel = function(param) {
    var data = param.data, children = param.children, peek = param.peek, itemsVisible = param.itemsVisible, enableTracking = param.enableTracking, _param_itemViewedCallback = param.itemViewedCallback, itemViewedCallback = _param_itemViewedCallback === void 0 ? null : _param_itemViewedCallback, navigationIconId = param.navigationIconId, carouselName = param.carouselName, pageBy = param.pageBy, wrapItems = param.wrapItems, className = param.className;
    var _nextButton, _previousButton;
    var nextButton = data.nextButton, previousButton = data.previousButton;
    var _nextButton_accessibility, _previousButton_accessibility;
    return /* @__PURE__ */ React3.createElement(UitkCarousel, {
        buttonText: {
            nextButton: (_nextButton_accessibility = (_nextButton = nextButton) === null || _nextButton === void 0 ? void 0 : _nextButton.accessibility) !== null && _nextButton_accessibility !== void 0 ? _nextButton_accessibility : "",
            prevButton: (_previousButton_accessibility = (_previousButton = previousButton) === null || _previousButton === void 0 ? void 0 : _previousButton.accessibility) !== null && _previousButton_accessibility !== void 0 ? _previousButton_accessibility : ""
        },
        navigationIconId: navigationIconId,
        itemsVisible: itemsVisible,
        pageBy: pageBy,
        peek: peek,
        itemViewedCallback: itemViewedCallback,
        carouselName: carouselName,
        className: className,
        wrapItems: wrapItems
    }, children);
};
EGDSCarousel.fragment = __fragment;
EGDSCarousel.displayName = "EGDSCarousel";
// src/components/reviews-carousel/reviews-carousel.tsx
var __Query = gql3(_templateObject2(), CardComponent.fragment, EGDSCarousel.fragment);
var ReviewsCarousel = function(param) {
    var skipSsr = param.skipSsr;
    var _reviewsCarousel, _reviewsCarousel1, _reviewsCarousel_heading, _reviewsCarousel2, _reviewsCarousel_heading1, _reviewsCarousel3, _reviewsCarousel_heading2, _reviewsCarousel4, _reviewsCarousel_carousel, _reviewsCarousel5, _reviewsCarousel6, _reviewsCarousel7, _reviewsCarousel_carousel1, _reviewsCarousel8;
    var context = useBexApi().context;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var reviewsCarousel = data.tripsReviewCollection.reviewsCarousel;
    var CardComponentPresentedData = ((_reviewsCarousel = reviewsCarousel) === null || _reviewsCarousel === void 0 ? void 0 : _reviewsCarousel.presentedAnalytics) ? {
        clientPayload: buildClientPayload("trip_review_module.presented", "Impression" /* IMPRESSION */ ),
        serverPayload: (_reviewsCarousel1 = reviewsCarousel) === null || _reviewsCarousel1 === void 0 ? void 0 : _reviewsCarousel1.presentedAnalytics
    } : null;
    return /* @__PURE__ */ React4.createElement(TripsReviewCollectionEgClickStreamImpressionTracker, {
        data: CardComponentPresentedData
    }, /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewLarge, null, /* @__PURE__ */ React4.createElement(UitkHeading, {
        tag: "h2",
        size: 4
    }, (_reviewsCarousel2 = reviewsCarousel) === null || _reviewsCarousel2 === void 0 ? void 0 : (_reviewsCarousel_heading = _reviewsCarousel2.heading) === null || _reviewsCarousel_heading === void 0 ? void 0 : _reviewsCarousel_heading.text)), /* @__PURE__ */ React4.createElement(ViewMedium, null, /* @__PURE__ */ React4.createElement(UitkHeading, {
        tag: "h2",
        size: 4
    }, (_reviewsCarousel3 = reviewsCarousel) === null || _reviewsCarousel3 === void 0 ? void 0 : (_reviewsCarousel_heading1 = _reviewsCarousel3.heading) === null || _reviewsCarousel_heading1 === void 0 ? void 0 : _reviewsCarousel_heading1.text)), /* @__PURE__ */ React4.createElement(ViewSmall, null, /* @__PURE__ */ React4.createElement(UitkHeading, {
        tag: "h2",
        size: 5
    }, (_reviewsCarousel4 = reviewsCarousel) === null || _reviewsCarousel4 === void 0 ? void 0 : (_reviewsCarousel_heading2 = _reviewsCarousel4.heading) === null || _reviewsCarousel_heading2 === void 0 ? void 0 : _reviewsCarousel_heading2.text))), /* @__PURE__ */ React4.createElement(UitkSpacing, {
        padding: {
            blockstart: "three"
        }
    }, ((_reviewsCarousel5 = reviewsCarousel) === null || _reviewsCarousel5 === void 0 ? void 0 : (_reviewsCarousel_carousel = _reviewsCarousel5.carousel) === null || _reviewsCarousel_carousel === void 0 ? void 0 : _reviewsCarousel_carousel.__typename) === "EGDSCarousel" && /* @__PURE__ */ React4.createElement(EGDSCarousel, {
        data: (_reviewsCarousel6 = reviewsCarousel) === null || _reviewsCarousel6 === void 0 ? void 0 : _reviewsCarousel6.carousel,
        itemsVisible: {
            lg: 3,
            md: 2,
            sm: 1,
            xl: 4
        },
        peek: true,
        wrapItems: true,
        pageBy: 2,
        enableTracking: true,
        carouselName: (_reviewsCarousel7 = reviewsCarousel) === null || _reviewsCarousel7 === void 0 ? void 0 : _reviewsCarousel7.__typename
    }, (_reviewsCarousel8 = reviewsCarousel) === null || _reviewsCarousel8 === void 0 ? void 0 : (_reviewsCarousel_carousel1 = _reviewsCarousel8.carousel) === null || _reviewsCarousel_carousel1 === void 0 ? void 0 : _reviewsCarousel_carousel1.items.map(function(item) {
        return item.__typename === "TripsReviewCollectionCarouselCard" && /* @__PURE__ */ React4.createElement(CardComponent, {
            data: item,
            key: item.id
        });
    }))));
};
ReviewsCarousel.displayName = "sharedui-ReviewsCarousel";
export { ReviewsCarousel };
//# sourceMappingURL=index.js.map